import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  position: relative;
  padding: 12px 16px 18px 16px;
  z-index: 10;
`;

interface ILabel {
  color: string;
}

export const Label = styled.h2<ILabel>`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 0;

  color: ${({ color }) => color};
`;

export const Content = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Icon = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  height: 16px;
  width: 16px;
`;

interface ItemProps {
  isDisabled?: boolean;
}

export const Item = styled.div<ItemProps>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};
  position: relative;
  color: ${beam.font.primary};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : '1')};

  & + & {
    margin-top: 8px;
  }
`;

export const Block = styled.div`
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  cursor: auto;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
`;

export const Close = styled.div`
  display: flex;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-top: 5px;
  height: 32px;
  width: 32px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;
